// React dependencies
import React from 'react';

// External dependencies
import PropTypes from 'prop-types';

// Internal dependencies
import AreaMap from '../../areaMap/areaMap';
import Images from '../../basics/Images';

/**
 * A wrapper component for Map used in POI
 */
const PoiMap = (props) => (
  <AreaMap
    isCalloutCoord
    showCalloutInfoWindow={false}
    mapHeight={props.mapHeight}
    calloutCoord={{ ...props.coord }}
    disabled={props.disabled}
    setCalloutCoord={props.onMarkerChange}
    zoom={props.zoom}
    markerIcon={props.markerIcon}
    additionalMarkers={props.additionalMarkers}
    isPoiMarker={props.isPoiMarker}
    markerScaledSize={props.markerScaledSize}
    autofitOnLoad
  />
);

PoiMap.defaultProps = {
  disabled:          false,
  onMarkerChange:    () => {},
  zoom:              16,
  markerIcon:        Images.Local.MarkerPoi,
  additionalMarkers: [],
  isPoiMarker:       false,
  markerScaledSize:  40,
};

PoiMap.propTypes = {
  mapHeight: PropTypes.number.isRequired,
  coord:     PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }).isRequired,
  disabled:          PropTypes.bool,
  markerIcon:        PropTypes.func,
  onMarkerChange:    PropTypes.func,
  zoom:              PropTypes.number,
  additionalMarkers: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  })),
  isPoiMarker:      PropTypes.bool,
  markerScaledSize: PropTypes.number,
};

export default PoiMap;
